import { PRE_SIGN_PARAMS } from '@/shared/config';

import { ParsedPresignParams } from '../config';

export const parsePresignParams = (
  searchParams: URLSearchParams,
): ParsedPresignParams => ({
  required: {
    signature: searchParams.get(PRE_SIGN_PARAMS.signature),
    clientKeyID: searchParams.get(PRE_SIGN_PARAMS.clientKeyID),
    timestampUnixMilli: searchParams.get(PRE_SIGN_PARAMS.timestampUnixMilli),
    userID: searchParams.get(PRE_SIGN_PARAMS.userID),
  },
  optional: {
    organizationID: searchParams.get(PRE_SIGN_PARAMS.organizationID),
    reportID: searchParams.get(PRE_SIGN_PARAMS.reportID),
  },
});
